import { Alert } from "@xola/ui-kit";
import React from "react";
import { Membership } from "types";
import { RedemptionRuleTransformer } from "@/components/Product/Membership/MembershipRestrictions/MembershipRedemptionRule.transformer";
import { useMembershipRedemptionRule } from "@/components/PurchaseCreate/hooks/useMembershipRedemptionRule";

interface MemberIdentificationInfoAlertProps {
    membership: Membership;
}

export const MemberIdentificationInfoAlert = ({ membership }: MemberIdentificationInfoAlertProps) => {
    const { data: redemptionPurchaseRule } = useMembershipRedemptionRule(membership);

    if (!redemptionPurchaseRule || !RedemptionRuleTransformer.isOrganizerRequired(redemptionPurchaseRule)) return null;

    return (
        <Alert className="mt-4">
            Members must carry a valid ID at the time of check-in to experiences booked with this membership
        </Alert>
    );
};
